import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { LogOut, ShieldCheck } from 'lucide-react';
import { fetchMe, logoutSession, clearAuthCache } from '../lib/auth';

/* AdminGate — protects every /admin/* route with the JWT cookie session.
   No key prompts here: unauthenticated visitors are sent to /login. */

export default function AdminGate({ children }) {
  const { pathname } = useLocation();
  const [state, setState] = useState('checking'); // checking | open | denied

  useEffect(() => {
    let on = true;
    try {
      if (sessionStorage.getItem('kx_demo') === '1') { setState('open'); return () => { on = false; }; }
    } catch { /* noop */ }
    fetchMe().then((u) => { if (on) setState(u && u.role === 'admin' ? 'open' : 'denied'); });
    return () => { on = false; };
  }, []);

  if (state === 'checking') {
    return <div className="min-h-screen bg-[#0B0D12] flex items-center justify-center text-neutral-500 text-sm">Verificando acceso…</div>;
  }

  if (state === 'denied') {
    return <Navigate to={`/login?next=${encodeURIComponent(pathname)}`} replace />;
  }

  const logout = async () => {
    await logoutSession();
    clearAuthCache();
    window.location.href = '/login';
  };

  return (
    <div className="relative">
      {!pathname.startsWith('/admin/ai-os') && (
        <div className="hidden md:block fixed bottom-4 right-4 z-[80]">
        <button
          onClick={logout}
          className="inline-flex items-center gap-1.5 rounded-full border border-white/15 bg-[#1B1F24]/95 backdrop-blur px-4 h-9 text-[12px] font-semibold text-neutral-300 hover:text-white hover:border-red-400/60 transition-colors shadow-lg"
          data-testid="admin-logout"
          title="Cerrar sesión de administrador"
        >
          <ShieldCheck className="w-3.5 h-3.5 text-emerald-400" /> Admin <LogOut className="w-3.5 h-3.5" />
        </button>
      </div>
      )}
      {children}
    </div>
  );
}
